import { render, staticRenderFns } from "./rms-objects-history-grid.vue?vue&type=template&id=5903d30c&scoped=true"
import script from "./rms-objects-history-grid.vue?vue&type=script&lang=js"
export * from "./rms-objects-history-grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903d30c",
  null
  
)

export default component.exports